export function buildProfileCardStyle(appearance, urlName, viewportWidth) {
    if (appearance?.type === "solid") {
        return { background: appearance.background };
    }

    const deviceFolder = viewportWidth <= 576 ? "mobile" : "desktop";
    return {
        backgroundImage: `url(${urlName}appearance/advance_background/${deviceFolder}/${appearance?.background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
    };
}

export function resolveProfileFontWeight(appearance) {
    const weight = appearance?.font_weight;
    if (weight === "bold") return 700;
    if (weight === "medium" || weight === "normal" || !weight) return 500;
    return weight;
}
